import { useState } from 'react'
import { getAutoSuggestedAddress } from '../providers/HereMapClient'
import { useLocale } from './useLocale'
import { logger } from '../utils/logger'
import { AutoCompleteAddress } from '../types/hereMaps'
import { useTranslation } from 'react-i18next'

export function useFetchAddress(
  fetchErrorCallback?: (message: string) => void,
) {
  const { t } = useTranslation()
  const [suggestedAddresses, setSuggestedAddresses] = useState<
    AutoCompleteAddress[]
  >([])
  const [showAddressSuggest, setShowAddressSuggest] = useState(false)

  const { countryCode } = useLocale()

  async function fetchAddress(input: string) {
    if (input.length > 2) {
      await getAutoSuggestedAddress(countryCode, input)
        .then((res) => {
          setSuggestedAddresses(res)
          setShowAddressSuggest(true)
        })
        .catch((err) => {
          logger('error', err)
          if (fetchErrorCallback) {
            fetchErrorCallback(t('errors.noMatchingAddress'))
          }
        })
    } else {
      setShowAddressSuggest(false)
    }
  }

  return {
    suggestedAddresses: suggestedAddresses,
    fetchAddress: fetchAddress,
    showAddressSuggest: showAddressSuggest,
    setShowAddressSuggest: setShowAddressSuggest,
  }
}
